/* eslint-disable no-unused-vars */
import { ProFormaModelIds } from 'constants/proForma';

export enum ColumnKeys {
    START_DATE = 'startDate',
    ANNUAL_GROWTH = 'annualGrowth',
    PERCENT_OF_TOTAL_RENT = 'percentOfTotalRent',
    PRICE_PER_SF = 'pricePerSf',
    PRICE_PER_SF_PER_YEAR = 'pricePerSfPerYear',
    PRICE_PER_UNIT = 'pricePerUnit',
}

export const COLUMN_KEYS_BY_MODEL_ID: Record<string, ColumnKeys[]> = {
    [ProFormaModelIds.APARTMENT]: [
        ColumnKeys.ANNUAL_GROWTH,
        ColumnKeys.PERCENT_OF_TOTAL_RENT,
        ColumnKeys.PRICE_PER_SF,
        ColumnKeys.PRICE_PER_UNIT,
    ],
    [ProFormaModelIds.RETAIL]: [
        ColumnKeys.START_DATE,
        ColumnKeys.ANNUAL_GROWTH,
        ColumnKeys.PERCENT_OF_TOTAL_RENT,
        ColumnKeys.PRICE_PER_SF_PER_YEAR,
    ],
    [ProFormaModelIds.OFFICE]: [
        ColumnKeys.START_DATE,
        ColumnKeys.ANNUAL_GROWTH,
        ColumnKeys.PERCENT_OF_TOTAL_RENT,
        ColumnKeys.PRICE_PER_SF_PER_YEAR,
    ],
    [ProFormaModelIds.INDUSTRIAL]: [
        ColumnKeys.START_DATE,
        ColumnKeys.ANNUAL_GROWTH,
        ColumnKeys.PERCENT_OF_TOTAL_RENT,
        ColumnKeys.PRICE_PER_SF_PER_YEAR,
    ],
    // add data center columns here
};
